import React from "react";

const Yasal_Uyari = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>YASAL UYARI VE TİCARİ İLİŞKİLER BEYANI</h1>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Hizmet Sunucusu ve Operasyonel Yapı</h2>
          <p style={styles.text}>
            Temelden.com.tr ve ilgili mobil uygulamalar (Temelden) ("Platform"), Von Dijital Yazılım Hizmetleri LTD. ŞTİ. ("Şirket") tarafından işletilmekte ve tescilli bir markasıdır. Şirket, Platform üzerinden sunduğu tüm dijital emlak hizmetlerini, Türkiye Cumhuriyeti mevzuatına ve sektörel düzenlemelere tam uyumlu şekilde yürütmektedir. Platform, yalnızca kendi bünyesinde akdettiği kurumsal iş birlikleri çerçevesinde hizmet vermektedir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Bağımsızlık ve Münhasırlık Beyanı</h2>
          <p style={styles.text}>
            Platformumuz; sektörde faaliyet gösteren diğer emlak ofisleri, emlak portalları, dijital pazarlama siteleri veya benzeri üçüncü şahıs tüzel kişiliklerle herhangi bir ortak girişim, stratejik ortaklık veya örtülü iş birliği içinde değildir. "Temelden" ismi ve türevleri altında faaliyet gösterdiği iddia edilen, şirketimizle resmi bir bağı bulunmayan her türlü oluşumun eylemlerinden ve beyanlarından hiçbir surette sorumluluk kabul etmemekteyiz.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Yetkisiz Temsil ve Dolandırıcılık Uyarısı</h2>
          <p style={styles.text}>
            Kurumsal üyelerimize yönelik olarak, şirketimiz veya Platformumuz adına hareket ettiğini iddia eden, üçüncü şahıs şirketler veya kişiler tarafından yapılan;
          </p>
          <ul style={styles.list}>
            <li>Ücretsiz veya ücretli hizmet teklifleri,</li>
            <li>Ödeme talep eden bildirimler,</li>
            <li>Sözde iş birliği önerileri,</li>
            <li>Resmi görünümlü sahte fatura veya sözleşmeler,</li>
          </ul>
          <p style={styles.text}>tamamen yetkisiz ve hukuka aykırıdır.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Resmi İletişim ve Doğrulama Yöntemi</h2>
          <p style={styles.text}>
            Platformumuz ile kurulacak tüm resmi ilişkilerde tek yetkili muhatap Von Dijital Yazılım Hizmetleri LTD. ŞTİ.'dir. Resmi iletişim kanallarımız şunlardır:
          </p>
          <ul style={styles.list}>
            <li>Kurumsal E-posta: info@vondigital.com.tr</li>
            <li>Adres: Göztepe Mah. Mithatpaşa Cad. Gürsoy No: 856/1B Konak/İzmir</li>
            <li>Web sitesi: https://www.vondigital.com.tr</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Hukuki Yaptırım ve Tazminat Hakkı</h2>
          <p style={styles.text}>
            Yetkisiz temsil ve marka itibarının suiistimali hallerinde;
          </p>
          <ul style={styles.list}>
            <li>556 sayılı Markaların Korunması Hakkında Kanun Hükmünde Kararname</li>
            <li>6098 sayılı Türk Borçlar Kanunu</li>
            <li>5237 sayılı Türk Ceza Kanunu</li>
            <li>6563 sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun</li>
          </ul>
          <p style={styles.text}>
            hükümleri uyarınca;
          </p>
          <ul style={styles.list}>
            <li>Tazminat davaları</li>
            <li>Ceza şikayetleri</li>
            <li>İhtiyati tedbir talepleri</li>
            <li>İnternet ortamında içeriğin kaldırılması başvuruları olmak üzere tüm hukuki yollara başvurulacaktır.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Uygulama ve Yürürlük</h2>
          <p style={styles.text}>
            Bu beyan, Platform'u kullanan tüm gerçek ve tüzel kişi üyeleri bağlayıcı niteliktedir. Şirket, tek taraflı olarak bu beyanda değişiklik yapma hakkını saklı tutar. Güncel versiyon daima{" "}
            <a href="https://www.temelden.com.tr/yasal_uyari" target="_blank" rel="noopener noreferrer" style={styles.link}>
              https://www.temelden.com.tr/yasal_uyari
            </a>{" "}
            adresinde yayınlanacaktır.
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
    color: "#555",
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

export default Yasal_Uyari;
